/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramTransactionsUserControllerCreateIosPaymentMutationRequest,
  TelegramTransactionsUserControllerCreateIosPaymentMutationResponse,
  TelegramTransactionsUserControllerCreateIosPayment400,
  TelegramTransactionsUserControllerCreateIosPayment401,
  TelegramTransactionsUserControllerCreateIosPayment404,
} from '../../types/TelegramTransactionsUserControllerCreateIosPayment.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramTransactionsUserCreateIosPayment } from '../../methods/telegramTransactionsUserCreateIosPayment.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramTransactionsUserCreateIosPaymentMutationKey = () =>
  [{ url: '/api/user/telegram/transactions/ios' }] as const;

export type TelegramTransactionsUserCreateIosPaymentMutationKey = ReturnType<
  typeof telegramTransactionsUserCreateIosPaymentMutationKey
>;

/**
 * {@link /api/user/telegram/transactions/ios}
 */
export function useTelegramTransactionsUserCreateIosPayment<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramTransactionsUserControllerCreateIosPaymentMutationResponse,
      ResponseErrorConfig<
        | TelegramTransactionsUserControllerCreateIosPayment400
        | TelegramTransactionsUserControllerCreateIosPayment401
        | TelegramTransactionsUserControllerCreateIosPayment404
      >,
      { data: TelegramTransactionsUserControllerCreateIosPaymentMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramTransactionsUserControllerCreateIosPaymentMutationRequest>> & {
      client?: typeof fetch;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramTransactionsUserCreateIosPaymentMutationKey();

  return useMutation<
    TelegramTransactionsUserControllerCreateIosPaymentMutationResponse,
    ResponseErrorConfig<
      | TelegramTransactionsUserControllerCreateIosPayment400
      | TelegramTransactionsUserControllerCreateIosPayment401
      | TelegramTransactionsUserControllerCreateIosPayment404
    >,
    { data: TelegramTransactionsUserControllerCreateIosPaymentMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramTransactionsUserCreateIosPayment(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
